import { useEffect, useRef } from 'react';
import { useAccessibilityModeEnabled } from '@frontend/accessibility';
import { accessibe } from '@frontend/tracking';
import { useRouterState } from '@frontend/weave-router';

export const AccessibilityModeRouteSync = () => {
  const { isEnabled } = useAccessibilityModeEnabled('isEnabled');
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const previousPathname = useRef(pathname);

  useEffect(() => {
    if (previousPathname.current !== pathname) {
      previousPathname.current = pathname;

      if (isEnabled) {
        accessibe.map();
      }
    }
  }, [isEnabled, pathname]);

  return null;
};
